const CheckSuccessGreen = () => (
  <svg
    width="46"
    height="46"
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="23" cy="23" r="23" fill="#74DFAC" />
    <path
      d="M13.9062 28.1271L18.429 31.7895C18.7177 32.0232 19.0788 32.1274 19.437 32.0804C19.7952 32.0334 20.1227 31.8388 20.3511 31.5373L32.0923 16.0449"
      stroke="white"
      strokeWidth="4"
      strokeLinecap="round"
    />
  </svg>
);
export default CheckSuccessGreen;
